import React, { useEffect, useState } from "react";

import FriendsList from "./friendList";
import Chat from "./chat";
import { FaUser } from "react-icons/fa";

const ChatManagemet = () => {
  const [activeFriend, setActiveFriend] = useState(null);

  return (
    <div className="h-screen flex ">
      <div className=" flex w-full border rounded-lg ">
        <FriendsList setActiveFriend={setActiveFriend} />
        <Chat activeFriend={activeFriend} />
      </div>
    </div>
  );
};

export default ChatManagemet;
